export default function ContactSection() {
  return (
    <footer className="relative w-full bg-secondary-500 py-20 md:py-28 lg:py-32 px-8 md:px-16 lg:px-24 overflow-hidden">
      <div className="max-w-[1400px] mx-auto relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16">
          <div>
            <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-accent-500/20 flex items-center justify-center mb-5">
              <div className="w-3 h-3 md:w-3.5 md:h-3.5 bg-accent-500 rounded-sm rotate-45"></div>
            </div>
            <p className="text-sm text-background-200/80 leading-relaxed font-light">
              A focused engineering team building scalable digital software with emphasis on quality, stability, and modern development practices.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-background-200/50 font-label mb-5">
              Address
            </h4>
            <p className="text-sm text-background-100 leading-loose font-light">
              Pakrascio g. 10-111
              <br />
              Vilnius
              <br />
              11342
              <br />
              Lithuania
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-background-200/50 font-label mb-5">
              Contact
            </h4>
            <p className="text-sm text-background-100 leading-loose font-light">
              +370 66803839
              <br />
              company@llngroups.com
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-background-200/50 font-label mb-5">
              Domains
            </h4>
            <p className="text-sm text-background-100 leading-loose font-light">
              iOS Engineering
              <br />
              Clean Architecture
              <br />
              Performance Design
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 select-none pointer-events-none">
        <div className="text-[clamp(80px,12vw,180px)] font-bold text-accent-500/15 font-heading leading-none tracking-[-0.04em] whitespace-nowrap overflow-hidden">
          ENGINEERING
        </div>
      </div>
    </footer>
  );
}